const decretosSolicitudes = [
  {
    path: "/decretos",
    name: "listado-decretos",
    component: () => import(/* webpackChunkName: "renuncias-listado" */ "./index.vue"),
  },
  {
    path: "/creacion-decreto",
    name: "crear-decretos",
    component: () => import(/* webpackChunkName: "renuncias-listado" */ "./views/decretoDeLey.vue"),
  },
  {
    path: "/ver-decreto/:id",
    name: "ver-decreto",
    meta: { isNotEdit: true }, 
    component: () => import(/* webpackChunkName: "renuncias-listado" */ "./views/decretoDeLey.vue"),
  },
  {
    path: "/editar-decreto/:id",
    name: "editar-decreto",
    meta: { isNotEdit: false }, 
    component: () => import(/* webpackChunkName: "renuncias-listado" */ "./views/decretoDeLey.vue"),
  },
];

export default decretosSolicitudes;